import {
    HOMEPAGE_FAILED,
    HOMEPAGE_FETCHING,
    HOMEPAGE_SUCCESS,
    LOGOUT,
} from "../../Constants.ts";

export interface HomePageState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: HomePageState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): HomePageState => {
    switch (type) {
        case HOMEPAGE_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case HOMEPAGE_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case HOMEPAGE_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        case LOGOUT:
            return initialState;
        default:
            return state;
    }
};
